import { render, staticRenderFns } from "./ImageOcr.vue?vue&type=template&id=8bd6b8ac&scoped=true"
import script from "./ImageOcr.vue?vue&type=script&lang=js"
export * from "./ImageOcr.vue?vue&type=script&lang=js"
import style0 from "./ImageOcr.vue?vue&type=style&index=0&id=8bd6b8ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd6b8ac",
  null
  
)

export default component.exports